/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "gRo0ZtgB2io",
    title: "All Too Well (Autumn Version) ",
    thumbnail:
      "https://i.ytimg.com/vi/gRo0ZtgB2io/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAMezumDEV8HMfaTrNc9vHDAnAoLw",
    description:
      "Official lyric video by Taylor Swift performing All Too Well (Sad Girl Autumn Version) – off her Red (Taylor’s Version) album.",
    creator: "Taylor Swift",
    category: "Music Videos",
    views: "20k",
    postedOn: 10,
  },
  {
    _id: "aXzVF3XeS8M",
    title: "Love Story Official Music Video ",
    thumbnail:
      "https://i.ytimg.com/vi/aXzVF3XeS8M/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDQffR5jOby-YKjwpAoDq7YOpbZXQ",
    description:
      "Official lyric video for “Love Story” (Taylor’s Version) – off her upcoming Fearless (Taylor’s Version) album. ",
    creator: "Taylor Swift",
    category: "Music Videos",
    views: "1M",
    postedOn: 11,
  },
  {
    _id: "SVY8I46dkb0",
    title: "Taylor Swift - Live at the 2019 American Music Awards",
    thumbnail:
      "https://i.ytimg.com/vi/SVY8I46dkb0/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA4BfJAk42Rkb1s223rRFjTYRaMjQ",
    description:
      "Taylor Swift performs at the 2019 American Music Awards (November 24th, 2019)",
    creator: "Taylor Swift",
    category: "Live Performances",
    views: "0.9M",
    postedOn: 28,
  },
  {
    _id: "s0Kfv835YRY",
    title: "Taylor Swift - Lover (Live From Paris)",
    thumbnail:
      "https://i.ytimg.com/vi/a4iTHPwioEc/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLC54UQXff7QitSAnZjBT2plYJ3Rvw",
    description:
      "Official lyric video by Taylor Swift performing All Too Well (Sad Girl Autumn Version) – off her Red (Taylor’s Version) album.",
    creator: "Taylor Swift",
    category: "Live Performances",
    views: "30K",
    postedOn: 12,
  },
  {
    _id: "RsEZmictANA",
    title: "Taylor Swift - willow (Official Music Video)",
    thumbnail:
      "https://i.ytimg.com/vi/RsEZmictANA/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDUG9mfmwoXf7g26ehhI_8OeYqKvA",
    description:
      "Official music video by Taylor Swift performing “willow” – off her evermore album.",
    creator: "Taylor Swift",
    category: "Music Videos",
    views: "2M",
    postedOn: 18,
  },
  {
    _id: "p1Zt47V3pPw",
    title: "Taylor performs Blank Space at The GRAMMY Museum",
    thumbnail:
      "https://i.ytimg.com/vi/p1Zt47V3pPw/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB3fMd9pVGTDdj_X7elJFkX9rAx5g",
    description:
      "Official lyric video by Taylor Swift performing All Too Well (Sad Girl Autumn Version) – off her Red (Taylor’s Version) album.",
    creator: "Taylor Swift",
    category: "Live Performances",
    views: "50K",
    postedOn: 13,
  },
  {
    _id: "3tmd-ClpJxA",
    title: "Look What You Made Me Do",
    thumbnail:
      "https://i.ytimg.com/vi/3tmd-ClpJxA/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAjY13HV8dqE4Xoax9tBh3d8hajbw",
    description:
      "Official lyric video by Taylor Swift performing All Too Well (Sad Girl Autumn Version) – off her Red (Taylor’s Version) album.",
    creator: "Taylor Swift",
    category: "Music Videos",
    views: "90K",
    postedOn: 24,
  },
  {
    _id: "ROEhlkY-NeY",
    title: "Taylor Swift - Funny Bloopers on Stage",
    thumbnail:
      "https://i.ytimg.com/vi/ROEhlkY-NeY/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCKZcUCfQj96fa5_-gSzDaY20vbog",
    description:
      "Official lyric video by Taylor Swift performing All Too Well (Sad Girl Autumn Version) – off her Red (Taylor’s Version) album.",
    creator: "Taylor Swift",
    category: "Bloopers",
    views: "10K",
    postedOn: 18,
  },
  {
    _id: "9_oeU3aNIAY",
    title: "Taylor Swift being herself for almost 11 minutes",
    thumbnail:
      "https://i.ytimg.com/vi/9_oeU3aNIAY/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAiu0utOewlZEIF98QgnuKlWpVOKg",
    description:
      "Official lyric video by Taylor Swift performing All Too Well (Sad Girl Autumn Version) – off her Red (Taylor’s Version) album.",
    creator: "Taylor Swift",
    category: "Bloopers",
    views: "15K",
    postedOn: 20,
  },
  {
    _id: "Ur_wAcYDnuA",
    title: "Taylor Swift - right where you left me (Official Lyric Video)",
    thumbnail:
      "https://i.ytimg.com/vi/Ur_wAcYDnuA/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDnzbzoNUAHc9dPd3FKZi4XouuERg",
    description:
      "Official lyric video by Taylor Swift performing All Too Well (Sad Girl Autumn Version) – off her Red (Taylor’s Version) album.",
    creator: "Taylor Swift",
    category: "Lyric Videos",
    views: "80K",
    postedOn: 20,
  },
  {
    _id: "nn_0zPAfyo8",
    title: "Taylor Swift – august (Official Lyric Video)",
    thumbnail:
      "https://i.ytimg.com/vi/nn_0zPAfyo8/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBSsz-o6X-nGD0sKKBYyW_lkhw5mQ",
    description:
      "Official lyric video by Taylor Swift performing All Too Well (Sad Girl Autumn Version) – off her Red (Taylor’s Version) album.",
    creator: "Taylor Swift",
    category: "Lyric Videos",
    views: "1M",
    postedOn: 19,
  },
  {
    _id: "tbEekLA7J3Y",
    title: "Taylor Swift - The Man (Lyric Video)",
    thumbnail:
      "https://i.ytimg.com/vi/tbEekLA7J3Y/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAz2HK1-12IMw9UMNQq-3hkMifbZA",
    description:
      "Official lyric video by Taylor Swift performing All Too Well (Sad Girl Autumn Version) – off her Red (Taylor’s Version) album.",
    creator: "Taylor Swift",
    category: "Lyric Videos",
    views: "1.2M",
    postedOn: 20,
  },
];
